// src/components/GainAccessForm.js
import React, { useState } from 'react';
import './AuthForms.css';

const GainAccessForm = ({ email, name, appName, switchToLogin }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleGainAccess = async () => {
    setError('');
    setLoading(true);

    try {
      const res = await fetch(process.env.REACT_APP_GAIN_ACCESS_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setSuccess(true);
      setTimeout(() => switchToLogin(), 3000);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      <form className="auth-form" onSubmit={(e) => e.preventDefault()}>
        <h2 className="app-title">{appName}</h2>
        <h2>Request Access</h2>

        {error && <div className="auth-error">{error}</div>}
        {success && <div className="auth-success">✅ Access granted! Redirecting to login...</div>}

        {!success && (
          <>
            <div className="auth-success" style={{ marginBottom: '1rem' }}>
              👋 Hey <strong>{name || email}</strong>, you're already a user on our system.<br />
              Click below to gain access to this app.
            </div>
            <button type="button" onClick={handleGainAccess} disabled={loading}>
              {loading ? 'Processing...' : 'Gain Access'}
            </button>
            <p className="auth-link">
              Changed your mind? <span onClick={switchToLogin}>Go back to login</span>
            </p>
          </>
        )}
      </form>
    </div>
  );
};

export default GainAccessForm;
